import { interaction } from "pixi.js";
import { Signal1 } from "@/js/util/event/Signal1";
import Disposable from "../util/disposable";

export default class Mouse implements Disposable {
  public down: Signal1<interaction.InteractionEvent>;
  public move: Signal1<interaction.InteractionEvent>;
  public up: Signal1<interaction.InteractionEvent>;

  constructor(manager: interaction.InteractionManager) {
    this.down = new Signal1();
    this.move = new Signal1();
    this.up = new Signal1();
    this._manager = manager;
    this._mouseDown = this.onmousedown.bind(this);
    this._mouseUp = this.onmouseup.bind(this);
    this._mouseMove = this.onmousemove.bind(this);
    this._manager.addListener("mousedown", this._mouseDown);
    this._manager.addListener("mouseup", this._mouseUp);
    this._manager.addListener("mousemove", this._mouseMove);
  }

  public dispose() {
    this._manager.removeListener("mousedown", this._mouseDown);
    this._manager.removeListener("mouseup", this._mouseUp);
    this._manager.removeListener("mousemove", this._mouseMove);
  }

  private onmousedown() {
    this.down.emit(this._manager.eventData);
  }

  private onmouseup() {
    this.up.emit(this._manager.eventData);
  }

  private onmousemove() {
    this.move.emit(this._manager.eventData);
  }

  private _manager: interaction.InteractionManager;
  private _mouseDown: () => void;
  private _mouseUp: () => void;
  private _mouseMove: () => void;
}
